import React from 'react'
import styles from '@style/PopSlidein/index.scss'
import PopSlidein from '@components/PopSlidein'
import { withTranslation } from '@hocs'
import SlideinItem from '@components/PopSlidein/SlideinItem'
import { imageAssetUrl } from '@libs/appUrl'

class SelectedCommentPop extends React.PureComponent {
  _onClickDelete = () => {
    const { onClickDelete, openConfirmDialog, t } = this.props
    openConfirmDialog({
      title: t('你確定要刪除此則評論嗎？'),
      onSure: () => onClickDelete(),
    })
  }

  _onClickReport = () => {
    const { onClickReport, openConfirmDialog, t } = this.props
    openConfirmDialog({
      title: t('是否檢舉此回覆?'),
      onSure: () => onClickReport(),
    })
  }

  render() {
    const { isOpen, isCurrentUserComment, t, onClose, onClickEdit } = this.props

    return (
      <PopSlidein isOpen={isOpen} close={onClose}>
        <div className="popSlidein__wrapper popSlidein__wrapper--info">
          <style jsx>{styles}</style>
          <div className="popSlidein__content popSlidein__content--info">
            <div className="popSlidein__actionIcons">
              {isCurrentUserComment ? (
                <>
                  <SlideinItem
                    onClick={onClickEdit}
                    img={imageAssetUrl('icon/share-edit@3x.png')}
                    text={t('編輯')}
                  />
                  <SlideinItem
                    onClick={this._onClickDelete}
                    img={imageAssetUrl('icon/share-delete@3x.png')}
                    text={t('刪除')}
                  />
                </>
              ) : (
                <>
                  <SlideinItem
                    onClick={this._onClickReport}
                    img={imageAssetUrl('icon/share-report@3x.png')}
                    text={t('檢舉')}
                  />
                </>
              )}
            </div>
          </div>
          <div className="btn cancel" onClick={onClose} data-btn-text={t('關閉')} />
        </div>
      </PopSlidein>
    )
  }
}

export default withTranslation()(SelectedCommentPop)
